<template>
  <Card>
    <Button type="primary" class="public-fr" icon="ios-undo" @click="back"
      >返回</Button
    >
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">激活信息</th>
      </tr>
      <tr>
        <th>物料名称</th>
        <td>{{ detail.name }}</td>
        <th>激活时间</th>
        <td>{{ detail.activationTime }}</td>
        <th>大区编码</th>
        <td>{{ detail.bgRpCode }}</td>
      </tr>
      <tr>
        <th>大区名称</th>
        <td>{{ detail.bgRpName }}</td>
        <th>渠道编码</th>
        <td>{{ detail.channelCode }}</td>
        <th>门店等级</th>
        <td>{{ detail.grade }}</td>
      </tr>
      <tr>
        <th>省份名称</th>
        <td>{{ detail.provinceName }}</td>
        <th>城市名称</th>
        <td>{{ detail.cityName }}</td>
        <th>陈列类型</th>
        <td>{{ detail.materialType }}</td>
      </tr>
      <tr>
        <th>纬度</th>
        <td>{{ detail.latitude }}</td>
        <th>经度</th>
        <td>{{ detail.longitude }}</td>
        <th>达能系统门店码</th>
        <td>{{ detail.mdmCode }}</td>
      </tr>
      <tr>
        <th>父级门店达e购ID</th>
        <td>{{ detail.parentRetCode }}</td>
        <th>打卡次数</th>
        <td>{{ detail.punchNum }}</td>
        <th>二维码编码</th>
        <td>{{ detail.qrCode }}</td>
      </tr>
      <tr>
        <th>门店ID</th>
        <td>{{ detail.retCode }}</td>
        <th>门店名称</th>
        <td>{{ detail.retName }}</td>
        <th>门店类型</th>
        <td>{{ detail.retType }}</td>
      </tr>
      <tr>
        <th>扫码次数</th>
        <td colspan="5">{{ detail.scanNum }}</td>
      </tr>
    </table>
  </Card>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let data = this.$route.query;
      this.$api.activationDetail(data).then((res) => {
        if (res.code == "200") {
          this.detail = res.data;
        }
      });
    },
    back() {
      this.$router.push({
        path: "activationList",
      });
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}
</style>





// WEBPACK FOOTER //
// src/views/material/activaDetail.vue